<template>
  <div class="flex flex-col lg:flex-row justify-center heightfix" v-if="!isGoogleLogging">
    <div class="lg:w-[45%] relative hidden lg:block">
      <!-- <img :src="login_logo" class="w-[200px] h-[30px] absolute top-8 left-8" alt="" /> -->
      <img
        :src="login_logo"
        class="w-[200px] h-[50px] absolute top-8 left-8 object-contain  lg:flex"
        alt=""
      />

      <img
        src="@/assets/newd/testbg.png"
        class="w-full h-[450px] lg:h-full  lg:flex"
        alt=""
      />
      <img
        src="@/assets/loginbg.svg"
        class="absolute bottom-0 h-[350px] lg:h-[580px]  2xl:h-[85%] lg:-right-[20%]  lg:flex"
        alt=""
      />
    </div>
    <div class="flex justify-center lg:hidden">
      <img
        :src="mobile_logo"
        class="w-[200px] h-[50px]  object-contain  lg:flex"
        alt=""
      />
    </div>

    <div
      class="flex flex-col gap-10 p-10 lg:items-center lg:w-[65%] lg:justify-center"
    >
      <form
        v-if="changeMenu === 'login'"
        @submit.prevent="loginUserss"
        class="lg:w-[50%] flex flex-col gap-4"
      >
        <h2 class="text-2xl lg:text-4xl font-bold">Sign in</h2>
        <p class="text-sm">Please fill your information below</p>

        <div>
          <label class="leading-7 text-sm text-gray-600">Email</label>
          <input
            @change="emptyspaceremove"
            ref="input"
            type="email"
            id="email"
            name="email"
            class="w-full bg-white rounded border border-gray-300 focus:primary-border focus:ring-2 focus:primary-border text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            placeholder="Email"
            required
          />
        </div>

        <div>
          <label class="leading-7 text-sm text-gray-600">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            class="w-full bg-white rounded border border-gray-300 focus:primary-border focus:ring-2 focus:primary-border text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            placeholder="Password"
            required
          />
          <img
            v-if="passwordType == 'password'"
            src="@/assets/eyeslash.svg"
            @click="hideShow('password')"
            alt=""
            class="cursor-pointer inline-block z-50"
            style="margin-left: -30px"
          />
          <img
            v-else
            src="@/assets/eye.svg"
            @click="hideShow('password')"
            alt=""
            class="cursor-pointer inline-block z-50"
            style="margin-left: -30px"
          />
        </div>

        <h1 v-if="loginError" class="text-red-700 font-semibold p-2 text-base">
          {{ loginError }}
        </h1>
        <h1
          v-if="credentialsError"
          class="text-red-700 font-semibold p-2 text-base"
        >
          {{ credentialsError }}
        </h1>

        <button
          type="button"
          @click="changeMenu = 'forget'"
          class="text-left px-2 py-1 text-sm text-sky-600 hover:text-red-500"
        >
          Forgot Password?
        </button>

        <div class="flex justify-end mt-4 bottom-2">
          <button
            v-if="!loading"
            type="submit"
            class="bg-black text-white py-2 px-6 text-sm rounded-lg hover:bg-blue-700 transition relative"
            style="background-color: #0f172a !important"
          >
            Login
          </button>
          <button
            v-if="loading"
            type="submit"
            class="bg-black text-white py-2 px-6 text-sm rounded-lg hover:bg-blue-700 transition relative"
            style="background-color: #0f172a !important"
          >
            Loading...
          </button>
        </div>

        <!-- <p class="text-center">Or</p>
        <div class="flex items-center justify-center">
          <GoogleLogin :callback="handleCredentialResponse" popup-type="TOKEN">
            <button
              type="button"
              @click="GoogleLogin"
              class="w-fit mx-auto flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-inter text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
            >
              <img
                class="h-5 w-5 mr-2"
                src="https://www.svgrepo.com/show/475656/google-color.svg"
                alt="Google logo"
              />
              Sign in with Google
            </button>
          </GoogleLogin>
        </div> -->
      </form>

      <form
        v-if="changeMenu === 'forget'"
        @submit.prevent="resetMail()"
        class="lg:w-[50%] flex flex-col gap-3"
      >
        <h2 class="text-2xl lg:text-4xl font-bold">Forgot Password</h2>

        <div>
          <label class="leading-7 text-sm text-gray-600">Email</label>
          <input
            @change="emptyspaceremove"
            ref="input"
            type="email"
            id="forget_email"
            name="email"
            class="w-full bg-white rounded border border-gray-300 focus:primary-border focus:ring-2 focus:primary-border text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            placeholder="Email"
            required
          />
        </div>

        <h1 v-if="loginError" class="text-red-700 font-semibold p-2 text-base">
          {{ loginError }}
        </h1>
        <h1
          v-if="credentialsError"
          class="text-red-700 font-semibold p-2 text-base"
        >
          {{ credentialsError }}
        </h1>

        <!-- <button type="button" @click="forgetpassWord()"
                    class="text-left px-2 py-1 text-sm text-sky-600 hover:text-red-500">
                    Forgot Password?
                </button> -->
        <p v-if="loginsuccess" class="text-green-400 font-semibold text-base">
          {{ loginsuccess }}
        </p>
        <p v-if="loginErrors" class="text-red-400 font-semibold text-base">
          {{ loginErrors }}
        </p>

        <button
          type="button"
          @click="changeMenu = 'login'"
          class="text-left px-2 py-1 text-sm text-sky-600 hover:text-red-500"
        >
          Login with Password?
        </button>

        <div class="flex justify-end mt-4 bottom-2">
          <button
            v-if="!loading"
            type="submit"
            class="bg-black text-white py-2 px-6 text-sm rounded-lg hover:bg-blue-700 transition relative"
            style="background-color: #0f172a !important"
          >
            Send Mail
          </button>
          <div v-if="loading" class="flex gap-5 items-center">
            <button
              type="submit"
              class="bg-black text-white py-2 px-6 text-sm rounded-lg hover:bg-blue-700 transition relative"
              style="background-color: #0f172a !important"
            >
              Loading...
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
export default {
  data: function () {
    return {
      login_logo: require(`${process.env.VUE_APP_LOGIN_COMS_LOGO}`),
      mobile_logo: require(`${process.env.VUE_APP_LOGIN_COMS_MOBILE_LOGO}`),
      login: {
        username: "",
        password: "",
      },
      loading: false,
      passwordType: "password",
      varificationPopup: true,
      credentialsError: "",
      messages: {
        text: "",
        type: "null",
      },
      ip_address: "",
      changeMenu: "login",
      isGoogleLogging: false,
      loginsuccess: null,
      loginErrors: null,
    };
  },
  created() {},
  // components: {
  //     Navigation,
  //     FlashMessage,
  // },
  computed: mapGetters(["userInfo", "loginError", "isAuthenticated"]),
  mounted() {
    //  console.log("demo login////",loginError)
    // this.$refs.input.focus()
    // document.querySelector("#mailDone").onclick = function () {
    //     this.$router.go()
    // }

    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.onload = this.initializeGoogleSignIn;
    document.head.appendChild(script);

    // alert(this.$router.param);

    if (this.$router.param != "") {
      this.handleCallbackforGoogle();
    }

    fetch("https://ipinfo.io/json")
      .then((response) => response.json())
      .then((data) => {
        this.ip_address = data.ip;
        // document.getElementById("ip-address").textContent =
        //       `IP Address: ${data.ip}`;
      })
      .catch((error) => {
        console.error("Error fetching IP address:", error);
        // document.getElementById("ip-address").textContent =
        //       "Unable to retrieve IP address.";
      });

    // console.log(`${process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID}`, "CLIENT ID");
  },
  methods: {
    ...mapActions([
      "loginUser",
      "subcription",
      "instructordetails",
      "loginWithGoogle",
      "getNotifications",
    ]),

    hideShow(id) {
      const passwordField = document.querySelector(`#${id}`);
      passwordField.getAttribute("type") === "password"
        ? passwordField.setAttribute("type", "text")
        : passwordField.setAttribute("type", "password");
      this.passwordType = document.querySelector(`#${id}`).getAttribute("type");
    },

    GoogleLogin() {
      const googleAuthUrl = "https://accounts.google.com/o/oauth2/auth";
      const params = {
        client_id: `${process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID}`,
        redirect_uri: `${process.env.VUE_APP_WEB_DOMAIN}`,
        response_type: "token",
        scope: "email profile openid",
        prompt: "consent",
      };
      const queryString = new URLSearchParams(params).toString();
      window.location.href = `${googleAuthUrl}?${queryString}`;
    },

    handleCallback() {
      const query = window.location.search.substring(1);
      const accessToken = query
        .split("&")
        .find((param) => param.startsWith("code"))
        ?.split("=")[1];
      if (accessToken) {
        // localStorage.setItem("access_token", accessToken);
        const data = new URLSearchParams();
        data.append("client_id", "2d2e9766-a68f-49cd-8c7d-2e5b1c730a49");
        data.append(
          "client_secret",
          "Fat8Q~~DrnZcMBvbWxv4GsZo0jUZce8o2ZFVMbLy"
        );
        data.append("code", accessToken);
        data.append("grant_type", "authorization_code");
        data.append("redirect_uri", "https://localhost:8080/");

        axios
          .post(
            `https://login.microsoftonline.com/6bab7765-c387-4d0d-9be7-7f5679251594/oauth2/v2.0/token`,
            data,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          )
          .then((response) => {
            // console.log(response, "datat::::");
            if (response) {
              if (response.status == 200) {
                console.log(response.access_token);
                console.log(response.data.access_token);
                localStorage.setItem(
                  "access_token",
                  response.data.access_token
                );
              }
              if (response.status == 400) {
                console.log(response.trace_id);
              }
            }
          })
          .catch((error) => {
            console.log(error, "error:::");
          });
      }
    },

    handleCallbackforGoogle() {
      const query = window.location.search.substring(1);
      const params = new URLSearchParams(query);

      // alert(query.split("&").find((param) => param.startsWith("code"))?.split("=")[1]);
      // alert(params);

      const accessToken = window.location.hash
        .substring(1)
        .split("&")
        .find((param) => param.startsWith("access_token"))
        ?.split("=")[1];

      if (accessToken) {
        this.isGoogleLogging = true;

        let data = {
          token: accessToken,
        };

        if (localStorage.getItem("message_token")) {
          data["device_token"] = localStorage.getItem("message_token");
        }

        this.exchangeTokenWithBackend("google", data);
      }
    },

    async exchangeTokenWithBackend(provider, payload) {
      this.loginWithGoogle(payload);

      // setTimeout(() => {
      //   // let subdata = this.userInfo;
      //   // this.subcription(subdata);
      //   // this.instructordetails(subdata);
      //   // this.isGoogleLogging = false;
      // }, 100);

      setTimeout(() => {
        this.getNotifications(this.userInfo);
        if (this.userInfo.user.permission == "student") {
          this.$router.push({
            name: "StudentHome",
          });
          this.isGoogleLogging = false;
        } else if (this.userInfo.user.permission == "instructor") {
          this.$router.push({
            name: "InstructorHome",
          });
          this.isGoogleLogging = false;
        } else if (this.userInfo.user.permission == "super_admin") {
          this.$router.push({
            name: "AdminHome",
          });
        } else if (this.userInfo.user.permission == "hod") {
          this.$router.push({
            name: "HodHome",
          });
          this.loading = false;
        } else if (this.userInfo.user.permission == "mentor") {
          this.$router.push({
            name: "MentorHome",
          });
          this.loading = false;
        } else if (this.userInfo.user.permission == "co-ordinator") {
          this.$router.push({
            name: "CoordinateHome",
          });
          this.loading = false;
        } else {
          this.$router.push({
            name: "organizationDashboard",
            params: {
              slug_id: this.userInfo.slug_id,
            },
          });
        }
      }, 200);
    },

    async loginUserss() {
  try {
    const data = {
      username: document.getElementById("email").value.toLowerCase(),
      password: document.getElementById("password").value,
      ip_address: this.ip_address,
    };

    if (localStorage.getItem("message_token")) {
      data["device_token"] = localStorage.getItem("message_token");
    }

    this.loading = true;
    this.loginError = "";

    // ✅ Capture the return value from Vuex action
    const userInfo = await this.loginUser(data);

    // ✅ Assign to local component state
    this.userInfo = userInfo;
    console.log("User info after login:", this.userInfo);

    if (!this.userInfo) {
      this.loginError = "Invalid login credentials";
      this.loading = false;
      return;
    }

    // ✅ Handle redirection based on role
    this.getNotifications(this.userInfo);

    const permission = this.userInfo.user.permission;

    switch (permission) {
      case "student":
        this.$router.push({ name: "StudentHome" });
        break;
      case "instructor":
        this.$router.push({ name: "InstructorHome" });
        break;
      case "hod":
        this.$router.push({ name: "HodHome" });
        break;
      case "mentor":
        this.$router.push({ name: "MentorHome" });
        break;
      case "co-ordinator":
        this.$router.push({ name: "CoordinateHome" });
        break;
      case "super_admin":
        this.$router.push({ name: "AdminHome" });
        break;
      default:
        this.$router.push({
          name: "organizationDashboard",
          params: { slug_id: this.userInfo.slug_id },
        });
    }

  } catch (error) {
    console.error("Login error:", error);
    this.loginError = "Something went wrong during login";
  } finally {
    this.loading = false;
  }
},

    handleSubmit: async function (e) {
      let is_activation;
      this.loading = true;

      let mailId = {
        email: e.target.elements.email.value.toLowerCase(),
      };
      // console.log(mailId,'emailis')
      await axios
        .post(`${process.env.VUE_APP_API}/email_verification/`, mailId)
        .then((response) => {
          if (response.data.message == "Email already verified") {
            is_activation = true;
            // console.log("Email already verified")
          } else if (response.data.message == "Invalid Email credentials") {
            // console.log(" invalid Email credentials")
            this.credentialsError = "Invalid credentials";
            setTimeout(() => {
              this.credentialsError = "";
              this.loading = false;
            }, 2000);
          } else {
            this.varificationPopup = false;
            is_activation = false;
            this.loading = false;
            //    console.log("Email not verified")
          }
        })
        .catch((error) => {
          console.log(error);
        });

      if (is_activation) {
        e.preventDefault();
        let data = {
          username: e.target.elements.email.value.toLowerCase(),
          password: e.target.elements.password.value,
        };
        // console.log(data,'user details')
        await this.loginUser(data);
        setTimeout(() => {
          let subdata = this.userInfo;
          this.subcription(subdata);
          this.instructordetails(subdata);
        }, 3000);

        setTimeout(() => {
          if (this.userInfo.user.permission == "student") {
            this.$router.push({
              name: "StudentHome",
            });
          } else if (this.userInfo.user.permission == "instructor") {
            this.$router.push({
              name: "Instructorcourse-list",
            });
          } else {
            this.$router.push({
              name: "organizationDashboard",
              params: {
                slug_id: this.userInfo.slug_id,
              },
            });
          }
        }, 3000);
      } else {
        console.log("MailID have a issue");
      }
    },

    resendActivationMail() {
      // console.log(document.querySelector("#email").value)
      this.varificationPopup = true;
      let mailId = {
        email: document.querySelector("#email").value,
      };
      axios
        .post(`${process.env.VUE_APP_API}/regenerate_token/`, mailId)
        .then((response) => {
          // console.log(response.data.message)
          if (response.data.message == "Email send") {
            this.messages = {
              text: "Email send",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
          }, 2500);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    resetMail() {
      this.loading = true;

      document.querySelector("#forget_email").value;

      const resetMail = {
        email: document.querySelector("#forget_email").value,
      };

      axios
        .post(`${process.env.VUE_APP_API}/api/password_reset/`, resetMail)
        .then((response) => {
          console.log("responseresponseresponseresponse", response);
          if (response.data.status == "OK") {
            this.loading = false;
            this.loginsuccess = "Email Send Successfully";

            setTimeout(() => {
              this.loginsuccess = "";
              this.changeMenu = "login";
            }, 2500);

            if (response.data.status == 200) {
              this.messages = {
                text: "Email send",
                type: "success",
              };
              document.querySelector("#forget_email").value = "";
              this.changeMenu = "login";
            } else {
              this.messages = {
                text: " Event Faild",
                type: "error",
              };
            }
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2500);
          }
        })
        .catch((error) => {
          console.log("error...", error);
          this.loginErrors =
            "We couldn't find an account associated with that email. Please try a different e-mail address.";
          setTimeout(() => {
            this.loginErrors = "";
            // this.changeMenu = "login";
            this.loading = false;
          }, 4500);
        });
    },
    emptyspaceremove(el) {
      el.target.value = el.target.value.trim();
    },

    handleCredentialResponse() {
      if (response.access_token) {
        try {
          const result = this.$store.dispatch(
            "loginWithGoogle",
            response.access_token
          );
          if (result.success) {
            this.message = "Login successful.";
            // setTimeout(() => {
            //   this.$router.push({ name: "DashboardView" });
            // }, 3000);
          } else {
            // this.errorMessage = result.error || "Login failed";
            // setTimeout(() => {
            //   this.errorMessage = "";
            // }, 3000);
          }
        } catch (error) {
          // console.error("Login failed:", error);
          // this.errorMessage = "Login failed. Please try again.";
          // setTimeout(() => {
          //   this.errorMessage = "";
          // }, 3000);
        }
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh) !important;
}
.spinner {
  --d: 8.6px;
  width: 1.5px;
  height: 1.5px;
  border-radius: 50%;
  color: #a6acb7;
  box-shadow: calc(1 * var(--d)) calc(0 * var(--d)) 0 0,
    calc(0.707 * var(--d)) calc(0.707 * var(--d)) 0 0.5px,
    calc(0 * var(--d)) calc(1 * var(--d)) 0 1px,
    calc(-0.707 * var(--d)) calc(0.707 * var(--d)) 0 1.4px,
    calc(-1 * var(--d)) calc(0 * var(--d)) 0 1.9px,
    calc(-0.707 * var(--d)) calc(-0.707 * var(--d)) 0 2.4px,
    calc(0 * var(--d)) calc(-1 * var(--d)) 0 2.9px;
  animation: spinner-a90wxe 1s infinite steps(8);
}

@keyframes spinner-a90wxe {
  100% {
    transform: rotate(1turn);
  }
}
</style>
